import { Avatar, Tabs } from '@mantine/core';
import type { ReactNode } from 'react';
import { IconUsers } from '../../components/icons';
import { t } from '../../texts/pl';

/** Wartość zakładki „wszyscy” – nie jest identyfikatorem osoby. */
export const ALL_PEOPLE = 'all';

interface Person {
  participantId: string;
  firstName: string;
  lastName?: string;
  isGuardian: boolean;
}

/**
 * US-408 AC-1: przełącznik osób z rodziny – zakładki z kółkiem inicjału (opiekun w kolorze marki, dzieci w pomarańczowym).
 * Wspólny dla „Zajęć rodziny”, strony edycji i agendy obsługi.
 */
export function PersonTabs({
  people,
  value,
  onChange,
  fullNames = false,
  rightSection,
  allLabel,
}: {
  people: Person[];
  value: string | undefined;
  onChange: (participantId: string) => void;
  /** Obsługa widzi imię i nazwisko – „Ty” nie ma tam sensu. */
  fullNames?: boolean;
  rightSection?: ReactNode;
  /** Dodatkowa pierwsza zakładka „wszyscy” (wartość `ALL_PEOPLE`). */
  allLabel?: string;
}) {
  return (
    <Tabs value={value ?? null} onChange={(id) => (id ? onChange(id) : undefined)}>
      <Tabs.List aria-label={t.editions.person} style={{ alignItems: 'center' }}>
        {allLabel ? (
          <Tabs.Tab
            value={ALL_PEOPLE}
            leftSection={
              <Avatar size={24} radius="xl" color="gray">
                <IconUsers size={14} />
              </Avatar>
            }
          >
            {allLabel}
          </Tabs.Tab>
        ) : null}
        {people.map((p) => (
          <Tabs.Tab
            key={p.participantId}
            value={p.participantId}
            leftSection={
              <Avatar size={24} radius="xl" color={p.isGuardian ? 'brand' : 'orange'}>
                {p.firstName.slice(0, 1).toUpperCase()}
              </Avatar>
            }
          >
            {fullNames ? `${p.firstName} ${p.lastName ?? ''}`.trim() : p.isGuardian ? `${p.firstName} (${t.registration.you})` : p.firstName}
          </Tabs.Tab>
        ))}
        {rightSection ? <div style={{ marginLeft: 'auto', paddingBottom: 4 }}>{rightSection}</div> : null}
      </Tabs.List>
    </Tabs>
  );
}
